import { render, staticRenderFns } from "./offer-edit.vue?vue&type=template&id=4b8e6cda"
import script from "./offer-edit.vue?vue&type=script&lang=js"
export * from "./offer-edit.vue?vue&type=script&lang=js"
import style0 from "./offer-edit.vue?vue&type=style&index=0&id=4b8e6cda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports